export default {
  // #region PAYMENTslip
  GET_LIST_PAYMENTSLIP_REQUEST: 'GET_LIST_PAYMENTSLIP_REQUEST',
  GET_LIST_PAYMENTSLIP_SUCCESS: 'GET_LIST_PAYMENTSLIP_SUCCESS',
  GET_LIST_PAYMENTSLIP_FAILURE: 'GET_LIST_PAYMENTSLIP_FAILURE',

  GET_DETAIL_PAYMENTSLIP_REQUEST: 'GET_DETAIL_PAYMENTSLIP_REQUEST',
  GET_DETAIL_PAYMENTSLIP_SUCCESS: 'GET_DETAIL_PAYMENTSLIP_SUCCESS',
  GET_DETAIL_PAYMENTSLIP_FAILURE: 'GET_DETAIL_PAYMENTSLIP_FAILURE',

  CREATE_REQUEST: 'CREATE_REQUEST',
  CREATE_SUCCESS: 'CREATE_SUCCESS',
  CREATE_FAILURE: 'CREATE_FAILURE',

  UPDATE_REQUEST: 'UPDATE_REQUEST',
  UPDATE_SUCCESS: 'UPDATE_SUCCESS',
  UPDATE_FAILURE: 'UPDATE_FAILURE',

  DELETE_REQUEST: 'DELETE_REQUEST',
  DELETE_SUCCESS: 'DELETE_SUCCESS',
  DELETE_FAILURE: 'DELETE_FAILURE',

  GET_LIST_ORDER_REQUEST: 'GET_LIST_ORDER_REQUEST',
  GET_LIST_ORDER_SUCCESS: 'GET_LIST_ORDER_SUCCESS',
  GET_LIST_ORDER_FAILURE: 'GET_LIST_ORDER_FAILURE',

  GET_CODE_PAYMENTSLIP_SUCCESS: 'GET_CODE_PAYMENTSLIP_SUCCESS',
  GET_CODE_PAYMENTSLIP_REQUEST: 'GET_CODE_PAYMENTSLIP_REQUEST',
  GET_CODE_PAYMENTSLIP_FAILURE: 'GET_CODE_PAYMENTSLIP_FAILURE',
  // #endregion
};
